export function nuxtUrl(url) {
    return `${process.env.VUE_APP_NUXT_BASE_URL}${url}`
}
